/**
 * Storeify quote-page product search uses:
 *   /search/suggest?q=…&section_id=quote-search
 * and expects #shopify-section-quote-search to contain JSON
 * { results_count, products: [...] }.
 *
 * This interceptor rewrites those requests to CSI Meilisearch via the app proxy.
 */
(function () {
  const config = window.CSI_SEARCH || {};
  const quoteSearchUrl = config.quoteSearchUrl || '/apps/csi-search/quote-search';
  const originalFetch = window.fetch.bind(window);

  function isQuoteSearchRequest(input) {
    try {
      const url = new URL(
        typeof input === 'string' ? input : input?.url || '',
        window.location.origin,
      );
      if (!url.pathname.includes('/search/suggest')) return null;
      if (url.searchParams.get('section_id') !== 'quote-search') return null;
      return url;
    } catch {
      return null;
    }
  }

  function wrapAsSectionHtml(payload) {
    const json = JSON.stringify(payload);
    return `<div id="shopify-section-quote-search" class="shopify-section">${json}</div>`;
  }

  window.fetch = function csiQuoteSearchFetch(input, init) {
    const suggestUrl = isQuoteSearchRequest(input);
    if (!suggestUrl) {
      return originalFetch(input, init);
    }

    const q = suggestUrl.searchParams.get('q') || '';
    const target = `${quoteSearchUrl}?q=${encodeURIComponent(q)}&limit=10`;

    return originalFetch(target, {
      ...init,
      headers: {
        ...(init && init.headers ? init.headers : {}),
        Accept: 'application/json',
      },
    })
      .then(async (response) => {
        let data = { results_count: 0, products: [] };
        try {
          data = await response.json();
        } catch {
          data = { results_count: 0, products: [] };
        }

        if (!response.ok || data.ok === false) {
          // Fall back to Shopify predictive section rendering
          return originalFetch(input, init);
        }

        const body = wrapAsSectionHtml({
          results_count: data.results_count ?? data.products?.length ?? 0,
          products: data.products ?? [],
        });

        return new Response(body, {
          status: 200,
          headers: { 'Content-Type': 'text/html; charset=utf-8' },
        });
      })
      .catch(() => originalFetch(input, init));
  };
})();
